<template>
  <v-dialog
    :value="true"
    persistent
  >
    <v-card>
      <v-card-title class="text-h3">
        {{ title }}
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
            <v-row class="my-2">
              <v-col>Редактируемый текст</v-col>
            </v-row>
            <v-textarea
              v-model="editedText"
              outlined
              rows="20"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            <v-row class="my-2">
              <v-col class="preview-label">
                Текст в HTML формате
              </v-col>
            </v-row>
            <div
              class="html-preview-box"
              v-html="editedText"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-row class="d-flex justify-sm-space-around">
          <v-col
            cols="12"
            sm="4"
            class="text-center"
          >
            <v-btn
              block
              color="primary"
              outlined
              @click="$emit('cancel')"
            >
              Отменить
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            class="text-center"
          >
            <v-btn
              block
              color="primary"
              @click="$emit('save', variableName, editedText)"
            >
              Сохранить
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "DialogEditor",
  // model: {
  //   prop: "editedText",
  //   event: "getEditedText"
  // },
  props: {
    title: {
      type: String,
      default: ""
    },
    rawText: {
      type: String,
      default: ""
    },
    variableName: {
      type: String,
    }
  },
  data: () => ({
    // editedText: ''
  }),
  computed: {
    editedText: {
      get () {
        return this.rawText
      },
      set (newValue) {
        this.$emit('update:rawText', newValue)
      }
    }
  },
  watch: {
    rawText: {
      handler (newVal) {
        this.editedText = newVal
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
/* Стили для правого окна, чтобы оно визуально соответствовало v-textarea */
.html-preview-box {
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  padding: 12px 16px;
  min-height: 354px; /* Примерная высота v-textarea на 12 строк */
  max-height: 500px;
  overflow-y: auto;
  background-color: #fafafa;
  font-family: Roboto, sans-serif;
}

/* Стилизация заголовка превью */
.preview-label {
  font-size: 1rem;
  letter-spacing: 0.0333333333em;
}

</style>
